import * as t from "io-ts";
import * as JsonResponse1 from "./JsonResponse1";
import * as Listing6 from "./Listing6";

export const codec = JsonResponse1.createCodec(
    Listing6.codec,
    t.type({}),
);

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    data: Listing6.newDefault(),
    meta: {},
});
